import { List } from "../Components/index.js";

export default [
    {
        path: "/bq-store/setting",
        component: List,
        name: "bq.store.setting",
        meta: {
            requiresAuth: true,
        },
    },
];
